import * as React from 'react';
import styled from '@emotion/styled';
import { GlobalStyles } from '@ordermygear/styles';
import { OMGTheme } from '@ordermygear/theme';
import Header from './Header';
import Footer from './Footer';
import { H2, Text } from '@ordermygear/typography';
import { Sale, Dealer } from '../../../../backend/shared/types';

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 800px;
  max-width: ${OMGTheme.breakpoints.md};
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
`;

type LayoutProps = {
  sale: Sale;
  dealer: Dealer;
  children: JSX.Element;
}

const Layout = (props: LayoutProps) => {
  const {
    sale,
    dealer
  } = props;
  return (
    <>
      <GlobalStyles />
      <Container>
        <Header sale={sale} dealer={dealer} />
          <>{props.children}</>
      </Container>
      <Footer sale={sale} dealer={dealer} />
    </>
  );
};

export default Layout;